export const CREATE_DM_URL            = '/chat/create/dm';
export const CREATE_CHANNEL_URL       = '/chat/create/channel';

export const CHAT_URL                 = '/chat/:chatId';
export const CHAT_DETAILS_URL         = '/chat/:chatId/details';

export const ATTACHMENT_URL           = '/attachment/:attachmentId';

export const INVITE_URL               = '/chat/:chatId/invite';
export const JOIN_CHANNEL_URL         = '/chat/:chatId/join';
export const LEAVE_CHANNEL            = '/chat/:chatId/leave';

export const USER_DETAILS             = '/user/:id/details';
export const USER_SETTINGS            = '/user/settings';

export const BROWSE                   = '/browse';

export const HOME                     = '/';

export const UPDOX_HELP             = '//help.updox.com/help';
